/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class PartyDialog extends SiteEntityDialog<PartyRow, any> {
        protected getFormKey() { return PartyForm.formKey; }
        protected getIdProperty() { return PartyRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRow.localTextPrefix; }
        protected getNameProperty() { return PartyRow.nameProperty; }
        protected getService() { return PartyService.baseUrl; }

        protected form = new PartyForm(this.idPrefix);

        constructor() {
            super();

            this.form.GicsSelection.change(e => {
                SecurityDialog.gicsSetFormValues(this.form, false, null);
            });
        }

        loadEntity(entity) {
            super.loadEntity(entity);
            SecurityDialog.gicsLoadEntity(entity, this.form);
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            SecurityDialog.gicsSaveEntity(entity);
            return entity;
        }

        protected onSaveSuccess(response) {
            Q.reloadLookup('Data.PartyManager');
            super.onSaveSuccess(response);
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push({
                cssClass: 'relationships-button',
                icon: 'fa fa-link',
                title: 'Relationships',
                onClick: () => {
                    var dlg = new PartyRelationshipsDialog();
                    dlg.grid.partyCode = this.entity.PartyCode;
                    dlg.dialogTitle = 'Party Relationships: ' + this.entity.Name;
                    dlg.dialogOpen();
                }
            });

            return buttons;
        }
    }
}